<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">STP/<a routerLink="../">OrdenPago</a>/Agregar</p>
    <h2 class="">STP - Registrar Orden de Pago</h2>
  </div>
</div>


<div class="content-block">
  <div class="dx-card responsive-paddings pt-2"> 
    <div class="flex flex-nowrap">
      <div class=" responsive-paddings flex-grow-1">
          <h3 class="">Orden de Pago</h3>
          <div class="round-border-2 p-3">
              <div class='dx-field'>
                  <div class='dx-field-label'>Monto</div>
                  <div class='dx-field-value'>
                      <dx-text-box [(value)]="ordenPago.monto">
                          <dx-validator>
                              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
              <div class='dx-field'>
                <div class='dx-field-label'>Cuenta Origen</div>
                <div class='dx-field-value'>
                    <dx-text-box [(value)]="ordenPago.cuentaOrgien">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
              <div class='dx-field'>
                  <div class='dx-field-label'>Cuenta Destino</div>
                  <div class='dx-field-value'>
                      <dx-text-box [(value)]="ordenPago.cuentaBeneficiario">
                          <dx-validator>
                              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
              <div class='dx-field'>
                  <div class='dx-field-label'>Institución</div>
                  <div class='dx-field-value'>
                      <dx-select-box [(value)]="ordenPago.institucionContraparte" [dataSource]="stp_instituciones" displayExpr="name" valueExpr="">
                          <dx-validator>
                              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                          </dx-validator>
                      </dx-select-box>
                   </div>
              </div>
              <div class='dx-field'>
                <div class='dx-field-label'>Concepto</div>
                <div class='dx-field-value'>
                    <dx-text-box [(value)]="ordenPago.concepto" class="uper-case">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
          </div>
      </div>
      <div class=" responsive-paddings flex-grow-1"></div>
      
    </div>
  </div>
</div>